<template>
    <v-btn icon @click="back">
        <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
    </v-btn>
</template>
<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'back-button',
        props: {
            fallbackRoute: {
                required: false,
                type: Object,
            },
        },
        computed: {
            ...mapState([
                'referer',
            ]),
        },
        methods: {
            ...mapActions([
                'setRefererRoute',
            ]),
            back() {
                if (this.referer !== '/') {
                    const ref = this.referer;

                    this.$router.push(ref);
                } else {
                    this.fallbackRoute ? this.$router.push(this.fallbackRoute) : this.$router.push('/');
                }
            },
        },
    };
</script>
